import styled from 'styled-components';
import { colors } from '../../styles/styles';

export const TagContainer = styled.div`
  padding: 6px 4px;
  background-color: ${colors.warmPink};
  color: ${colors.white};
  font-weight: 700;
  font-size: 12px;
  text-align: center;
`;
